import React from 'react';
import { TourProps } from 'antd';
import { TourStep } from '../store/slices/tour.slice';
import { QuestionCircleOutlined } from '@ant-design/icons';

export interface ComprehensiveTourStepProps {
  target: string;
  title: React.ReactNode;
  description: React.ReactNode;
  cover?: React.ReactNode;
  placement?: TourProps['placement'];
  mask?: boolean;
  type?: 'default' | 'primary';
}

// 1. Kontrol Paneli (Header tour'ları da dahil)
export const dashboardSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="dashboard-stats"]',
    title: 'Kontrol Paneli',
    description: (
      <div>
        <p><strong>Dinox'a hoş geldiniz!</strong></p>
        <p>Bu ana kontrol panelinde şirketinizin genel durumunu görebilirsiniz:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Günlük çalışan istatistikleri</li>
          <li>Giriş-çıkış özeti</li>
          <li>Performans göstergeleri</li>
          <li>Önemli bildirimler</li>
        </ul>
        <p style={{ marginTop: '15px', color: '#000011', fontWeight: '500' }}>
          Bu kapsamlı tur ile tüm özellikleri keşfedeceğiz!
        </p>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  },
  {
    target: '[data-tour="notifications"]',
    title: 'Bildirimler',
    description: (
      <div>
        {/* <p><strong>Bildirim Merkezi</strong></p> */}
        <p>Burada şu bildirimleri görebilirsiniz:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Yeni izin talepleri</li>
          <li>Destek talepleri</li>
          <li>Sistem uyarıları</li>
          <li>Mazeret Bildirimleri</li>
          {/* <li>📊 Rapor hazır bildirimleri</li> */}
        </ul>
      </div>
    ),
    placement: 'bottomLeft',
    mask: true
  },
  {
    target: '[data-tour="profile-menu"]',
    title: 'Profil Menüsü',
    description: (
      <div>
        {/* <p><strong>Profil ve Hesap Ayarları</strong></p> */}
        <p>Bu menüden şunlara erişebilirsiniz:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Profil ayarları</li>
          <li>Güvenlik ayarları</li>
          <li>Güvenli çıkış</li>
          {/* <li>🌍 Dil değiştirme</li> */}
        </ul>
      </div>
    ),
    placement: 'bottomLeft',
    mask: true
  }
];

// Header tour'ları dashboard'a dahil edildi

// 3. Çalışan Listesi
export const employeesSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="employees-table"]',
    title: 'Çalışan Listesi',
    description: (
      <div>
        {/* <p><strong>Çalışan Listesi</strong></p> */}
        <p>Bu sayfada şirketinizdeki tüm çalışanları yönetebilirsiniz:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Yeni çalışan ekleme</li>
          <li>Çalışan bilgilerini düzenleme</li>
          <li>Detaylı çalışan profillerini görüntüleme</li>
          <li>Gelişmiş arama ve filtreleme</li>
          {/* <li>📊 Toplu işlemler</li> */}
        </ul>
      </div>
    ),
    placement: 'top',
    mask: true,
    type: 'primary'
  },
  {
    target: '[data-tour="add-employee"]',
    title: 'Yeni Çalışan Ekle',
    description: (
      <div>
        {/* <p><strong>Çalışan Ekleme</strong></p> */}
        <p>Bu buton ile yeni çalışan ekleyebilirsiniz. Form şunları içerir:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Kişisel bilgiler</li>
          <li>İş bilgileri</li>
          <li>İletişim bilgileri</li>
          <li>Güvenlik ayarları</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true
  }
];

// 4. Departmanlar
export const departmentsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="departments-list"]',
    title: 'Departman Yönetimi',
    description: (
      <div>
        {/* <p><strong>Departmanlar</strong></p> */}
        <p>Şirketinizdeki departmanları organize edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Yeni departman oluşturma</li>
          <li>Departman Düzenleme</li>
          <li>Departman Çalışma Saatleri Düzenleme</li>
          <li>Departman Çalışma Günleri Düzenleme</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 5. Şubeler
export const branchesSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="branches-list"]',
    title: 'Şube Yönetimi',
    description: (
      <div>
        {/* <p><strong>Şubeler</strong></p> */}
        <p>Farklı lokasyonlardaki şubelerinizi yönetin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Yeni şube ekleme</li>
          <li>Lokasyon bilgileri</li>
          {/* <li>👥 Şube personeli</li> */}
          <li>Kontrol edilecek IP adreslerini düzenleme</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 6. Giriş Çıkış Raporu
export const attendanceReportSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="attendance-report"]',
    title: 'Giriş Çıkış Raporu',
    description: (
      <div>
        {/* <p><strong>Devam Durumu Takibi</strong></p> */}
        <p>Çalışanlarınızın giriş-çıkış verilerini analiz edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Günlük giriş-çıkış saatleri</li>
          <li>Tarih bazlı raporlama</li>
          <li>Geç kalma analizi</li>
          {/* <li>Devam oranları</li> */}
          <li>Excel/PDF export</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 7. Vardiyalar
export const shiftsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="shifts-list"]',
    title: 'Vardiya Yönetimi',
    description: (
      <div>
        {/* <p><strong>Vardiya Sistemi</strong></p> */}
        <p>Esnek çalışma saatlerini organize edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Vardiya oluşturma</li>
          <li>Departman ve Şube bazlı planlama</li>
          <li>Toplu vardiya atama sistemi</li>
          <li>İstenilen tarih aralığında vardiya atama</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 8. İzinler
export const leavesSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="leaves-list"]',
    title: 'İzin Yönetimi',
    description: (
      <div>
        {/* <p><strong>İzin Talepleri</strong></p> */}
        <p>Çalışan izinlerini etkin bir şekilde yönetin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>İzin talep onayı</li>
          <li>İzin Listesi</li>
          <li>İzin türleri (yıllık, sağlık, vb.)</li>
          {/* <li>İzin bakiye takibi</li> */}
          <li>İzin raporları</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 9. Talepler
export const ticketsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="tickets-list"]',
    title: 'Destek Talepleri',
    description: (
      <div>
        {/* <p><strong>Ticket Yönetimi</strong></p> */}
        <p>Çalışanlardan gelen talepleri yönetin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Yeni talep değerlendirme</li>
          {/* <li>Öncelik belirleme</li> */}
          <li>Talep yanıtlama</li>
          <li>Talep istatistikleri</li>
          <li>Çözüm takibi</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 10. Çıkış Yapmayanlar
export const forgotCheckoutSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="forgot-checkout"]',
    title: 'Çıkış Yapmayanlar',
    description: (
      <div>
        {/* <p><strong>Çıkış Kontrolü</strong></p> */}
        <p>Çıkış yapmayı unutan çalışanları yönetin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Çıkış yapmayan listesi</li>
          <li>Çıkış saatini güncelleme</li>
          {/* <li>Çıkış nedeni belirtme</li> */}
          {/* <li>Çıkış unutma istatistikleri</li> */}
          {/* <li>Otomatik hatırlatma</li> */}
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 11. Giriş Yapmayanlar
export const forgotCheckinSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="forgot-checkin"]',
    title: 'Giriş Yapmayanlar',
    description: (
      <div>
        {/* <p><strong>Giriş Kontrolü</strong></p> */}
        <p>O gün giriş yapmayan çalışanları görün:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Giriş yapmayan çalışan listesi</li>
          {/* <li>Tarih bazlı filtreleme</li> */}
          <li>İzinli olanları ayırma</li>
          <li>Günlük takip</li>
          {/* <li>Devamsızlık analizi</li> */}
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 12. Zimmet Yönetimi
export const assetsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="assets-list"]',
    title: 'Zimmet Yönetimi',
    description: (
      <div>
        {/* <p><strong>Şirket Varlıkları</strong></p> */}
        <p>Çalışanlara verilen şirket malzemelerini takip edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Elektronik cihazlar</li>
          <li>Araç zimmetleri</li>
          <li>Telefon ve tablet</li>
          <li>Ofis malzemeleri</li>
          <li>Zimmet durumu takibi</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 13. Yemek Yönetimi
export const mealsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="meals-list"]',
    title: 'Yemek Yönetimi',
    description: (
      <div>
        {/* <p><strong>Yemek Servisi</strong></p> */}
        <p>Çalışan yemek hizmetlerini organize edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Günlük menü planlama</li>
          <li>Haftalık menü planlama</li>
          <li>Yemek listesi oluşturma</li>
          <li>Yemek takvimi</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

export const shiftReportSteps: ComprehensiveTourStepProps[] = [

    {
        target: '[data-tour="shift-report"]',
        title: 'Performans Raporu',
        description: (
          <div>
            {/* <p><strong>Vardiya & Performans Analizi</strong></p> */}
            <p>Vardiya bazlı performansı değerlendirin:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Vardiya verimliliği</li>
              <li>Departman performansı</li>
              <li>Üretkenlik metrikleri</li>
              <li>Karşılaştırmalı analiz</li>
            </ul>
          </div>
        ),
        placement: 'bottom',
        mask: true,
        type: 'primary'
      },
]
export const leaveReportSteps: ComprehensiveTourStepProps[] = [

    {
        target: '[data-tour="leave-report"]',
        title: 'İzin Raporu',
        description: (
          <div>
            {/* <p><strong>İzin Kullanım Analizi</strong></p> */}
            <p>İzin trendlerini ve kullanımını analiz edin:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Seçilen tarih aralığındaki izin raporlaması</li>
              <li>İzin kullanım oranları</li>
              <li>Sezonsal Yoğunluk</li>
            </ul>
          </div>
        ),
        placement: 'bottom',
        mask: true,
        type: 'primary'
      },
]
export const breakReportSteps: ComprehensiveTourStepProps[] = [
    {
        target: '[data-tour="break-report"]',
        title: 'Mola Raporu',
        description: (
          <div>
            {/* <p><strong>Mola Kullanım Analizi</strong></p> */}
            <p>Çalışan mola alışkanlıklarını inceleyin:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Süre, tarih ve departman bazlı mola raporları</li>
              <li>Mola süresi ve mola adetleri</li>
              <li>En çok mola alan çalışanlar</li>
            </ul>
          </div>
        ),
        placement: 'bottom',
        mask: true,
        type: 'primary'
      },
]
export const documentsSteps: ComprehensiveTourStepProps[] = [

  {
    target: '[data-tour="documents"]',
    title: 'Belgeler',
    description: (
      <div>
        {/* <p><strong>Doküman Yönetimi</strong></p> */}
        <p>Şirket belgelerini organize edin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Çalışan belgeleri</li>
          <li>Kullanıcıya belge ekleme</li>
          {/* <li>Şirket politikaları</li> */}
          <li>Belgeyi kullanıcıya gizleme</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  },
]
export const timesheetReportSteps: ComprehensiveTourStepProps[] = [
    {
        target: '[data-tour="timesheet-report"]',
        title: 'Puantaj & Maaş',
        description: (
          <div>
            {/* <p><strong>Bordro & Puantaj</strong></p> */}
            <p>Maaş hesaplama için gerekli verileri görün:</p>
            <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
              <li>Maaş hesaplamaları</li>
              <li>Çalışma saati özetleri</li>
              <li>Ek mesai hesapları</li>
              <li>Bordro raporları</li>
            </ul>
          </div>
        ),
        placement: 'bottom',
        mask: true,
        type: 'primary'
      }
]

// 14-19. Raporlar
export const employeeReportSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="employee-report"]',
    title: 'Çalışan Raporu',
    description: (
      <div>
        {/* <p><strong>Detaylı Çalışan Analizi</strong></p> */}
        <p>Çalışan performansını değerlendirin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Eğitim seviyesi dağılımı</li>
          <li>Medeni durum dağılımı</li>
          <li>Şube bazlı çalışan dağılımı</li>
          <li>Cinsiyet dağılımı</li>
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  },
];

// 20. Şirket Ayarları
export const companySettingsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="company-settings"]',
    title: 'Şirket Ayarları',
    description: (
      <div>
        {/* <p><strong>Sistem Konfigürasyonu</strong></p> */}
        <p>Şirketinize özel ayarları yapılandırın:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Şirket bilgileri</li>
          {/* <li>Çalışma saatleri</li> */}
          <li>Bildirim ayarları</li>
          <li>SMS Yönetimi</li>
          <li>Abonelik yönetimi</li>
        </ul>
        {/* <p style={{ marginTop: '15px', color: '#52c41a', fontWeight: '500' }}>
          💡 Her tab için ayrı detaylı tur mevcut!
        </p> */}
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 21. Bildirim
export const notificationsSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="notification-settings"]',
    title: 'Bildirim Yönetimi',
    description: (
      <div>
        {/* <p><strong>Bildirim Sistemi</strong></p> */}
        <p>Çalışanlara bildirim gönderin:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Genel duyurular</li>
          <li>Kişisel bildirimler</li>
          <li>Departman ve şube bazlı mesajlar</li>
          <li>Acil durum bildirimleri</li>
          {/* <li>Bildirim istatistikleri</li> */}
        </ul>
      </div>
    ),
    placement: 'bottom',
    mask: true,
    type: 'primary'
  }
];

// 22. Tour Butonu
export const tourButtonSteps: ComprehensiveTourStepProps[] = [
  {
    target: '[data-tour="tour-button"]',
    title: 'Tur Butonu',
    description: (
      <div>
        {/* <p><strong>Tur Sistemi</strong></p> */}
        <p>Bu butonu kullanarak:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li>Turu istediğiniz zaman yeniden başlatabilirsiniz</li>
          <li>Yeni özellikler hakkında bilgi alabilirsiniz</li>
          <li>Sistem kullanımı hakkında yardım alabilirsiniz</li>
        </ul>
        <p style={{ marginTop: '15px', color: '#52c41a', fontWeight: '600' }}>
          Tebrikler! Dinox Admin Panel turunu tamamladınız!
        </p>
      </div>
    ),
    placement: 'bottomLeft',
    mask: true,
    type: 'primary'
  }
];

// Ana fonksiyon - tour step'ine göre ilgili adımları döner
export const getComprehensiveTourSteps = (step: TourStep): ComprehensiveTourStepProps[] => {
  switch (step) {
    case 'dashboard':
      return dashboardSteps;
    case 'employees':
      return employeesSteps;
    case 'departments':
      return departmentsSteps;
    case 'branches':
      return branchesSteps;
    case 'attendance-report':
      return attendanceReportSteps;
    case 'shifts':
      return shiftsSteps;
    case 'leaves':
      return leavesSteps;
    case 'tickets':
      return ticketsSteps;
    case 'forgot-checkout':
      return forgotCheckoutSteps;
    case 'forgot-checkin':
      return forgotCheckinSteps;
    case 'assets':
      return assetsSteps;
    case 'meals':
      return mealsSteps;
    case 'employee-report':
      return employeeReportSteps;
    case 'shift-report':
      return shiftReportSteps;
    case 'leave-report':
      return leaveReportSteps;
    case 'break-report':
      return breakReportSteps;
    case 'documents':
      return documentsSteps;
    case 'timesheet-report':
      return timesheetReportSteps;
    case 'company-settings':
      return companySettingsSteps;
    case 'notifications':
      return notificationsSteps;
    case 'tour-button':
      return tourButtonSteps;
    case 'completed':
      return [{
        target: 'body',
        title: 'Tur Tamamlandı!',
        description: (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ fontSize: '18px', fontWeight: '600', color: '#52c41a' }}>
              Tebrikler! Dinox Admin Panel'i keşfettiniz! 🚀
            </p>
            <p style={{ marginTop: '15px' }}>
              Artık tüm özellikleri kullanarak şirketinizi daha etkin yönetebilirsiniz.
            </p>
            <p style={{ marginTop: '10px', color: '#52c41a' }}>
              İhtiyacınız olduğunda <QuestionCircleOutlined style={{ fontSize: '20px', color: '#52c41a'}}/> butonundan turu tekrar başlatabilirsiniz.
            </p>
          </div>
        ),
        placement: 'center',
        mask: true,
        type: 'primary'
      }];
    default:
      return [];
  }
};
